<script setup lang="ts">
    const props = withDefaults(
        defineProps<{
            field1Class?: string;
            field2Class?: string;
            containerClass?: string;
        }>(),
        {
            containerClass: 'lg:flex gap-2',
            field1Class: 'w-full',
            field2Class: 'w-full',
        }
    );
</script>

<template>
    <div :class="containerClass">
        <div :class="field1Class">
            <slot name="field-1"></slot>
        </div>
        <div :class="field2Class">
            <slot name="field-2"></slot>
        </div>
    </div>
</template>
